import gql from 'graphql-tag';

const CREATE_ALERT_TICKET_DATA = gql`
  mutation($input: TicketDataInput!) {
    createTicketData(input: $input) {
      dataId
      name
      subject
      description
      placeholdersUsed
    }
  }
`;

const UPDATE_ALERT_TICKET_DATA = gql`
  mutation($input: TicketDataInput!) {
    updateTicketData(input: $input) {
      dataId
    }
  }
`;

const GET_TICKET_TEMPLATE_LIST = gql`
  query getTicketDataList($listInfo: ListInfoInput!) {
    getTicketDataList(listInfo: $listInfo) {
      ticketData {
        dataId
        name
        subject
      }
    }
  }
`;

const GET_FIELDS_META_FOR_TICKET_TEMPLATE = gql`
  query {
    getTicketDataMetaInfo
  }
`;

const GET_ALERT_SEVERITY_LIST = gql`
  query {
    getAlertSeverityTypes {
      id
      name
      colorCode
    }
  }
`;

const GET_ASSET_LIST_BY_POLICY_SET = gql`
  query($classId: ID!, $policySetId: ID!, $listInfo: ListInfoInput!) {
    getAssetListByPolicySet(
      classId: $classId
      policySetId: $policySetId
      listInfo: $listInfo
    ) {
      assets {
        assetId
        name
        client {
          name
          accountId
        }
        site {
          name
          id
        }
        assetClass {
          name
        }
      }
      listInfo {
        page
        pageSize
        totalCount
        hasMore
      }
    }
  }
`;

const GET_TICKET_TEMPLATE = gql`
  query getTicketData($input: TicketDataIdentifierInput!) {
    getTicketData(input: $input) {
      dataId
      name
      subject
      description
      status
      priority
      impact
      urgency
      category
      customFields
      placeholdersUsed
    }
  }
`;

export {
  CREATE_ALERT_TICKET_DATA,
  GET_TICKET_TEMPLATE_LIST,
  GET_FIELDS_META_FOR_TICKET_TEMPLATE,
  UPDATE_ALERT_TICKET_DATA,
  GET_ALERT_SEVERITY_LIST,
  GET_ASSET_LIST_BY_POLICY_SET,
  GET_TICKET_TEMPLATE
};
